import * as React from "react";
import Button from "../Button";

const CardWithLable = ({
  title,
  children,
  dropDownWhiteBg,
  img,
  alt,
  cardSpacing,
}) => {
  return (
    <div
      className={cardSpacing === "primary" ? "hf-card2 mb-3" : "hf-card2 h-100"}
    >
      <div className="hf-card2-header">
        <div className="inner1">
          <div className="Fund-FontSize" 
          // className="hf-card2-title"
          >{title}</div>
        </div>
        <div className="inner2">
          <div className="mr-2">{dropDownWhiteBg}</div>
          <div className="drag-icon-box">
            <img src={img} alt={alt} />
          </div>
        </div>
        <hr />
      </div>
      {children}
    </div>
  );
};

export default CardWithLable;
